/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import {
	store
} from '@/store/store'
import url from '@/services/ApiServices/apiUrls'
import {
	productApi
} from './productApi'
import router from '../../router'

export function setDefaultCountryAndCurrency (tenantData) {
	store.dispatch('siteData/setTenantConfig', tenantData)
	const baseCurrency = tenantData.base_currency
	const countriesWithShipping = tenantData.currencies
	store.dispatch('siteData/setCountriesWithShipping', countriesWithShipping)
	const defaultSelectedCountry = countriesWithShipping
		.find(country => country.currency_name.toLowerCase() === baseCurrency.toLowerCase())
	const currentSelectedCountry = store.getters['siteData/getSelectedCountry']
	if (currentSelectedCountry && currentSelectedCountry.currency_name) {
		const selectedCountry = countriesWithShipping
			.find(country => currentSelectedCountry.currency_name === country.currency_name)
		if (selectedCountry) {
			store.dispatch('siteData/setChosenCountryData', selectedCountry)
		} else if (defaultSelectedCountry) {
			store.dispatch('siteData/setChosenCountryData', defaultSelectedCountry)
		}
	} else if (defaultSelectedCountry) {
		store.dispatch('siteData/setChosenCountryData', defaultSelectedCountry)
	}
}

export const customerApi = new Vue({
	methods: {
		addAddress (user) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.addAddress, user)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(e.data.message, {
							position: 'bottom-center'
						})
						reject(e)
					})
			})
		},
		subscribe (emailId) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.subscribeNewsletter, emailId)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show('email id may be incorrect', {
							theme: 'toasted-primary',
							position: 'bottom-right'
						})
						reject(e)
					})
			})
		},
		unsubscribe (emailId) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.unsubscribeNewsletter, emailId)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show('email id may not be registered', {
							theme: 'toasted-primary',
							position: 'bottom-right'
						})
						reject(e)
					})
			})
		},
		tenantRequest (user) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.tenantRequest, user)
					.then((res) => {
						Vue.toasted.show('Your Tenant Request Successfully Registered.', {
							position: 'top-center'
						})
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 400) {
							Vue.toasted.show('userName already exist.', {
								icon: 'exclamation-circle'
							})
						}
						if (e.status === 500) {
							Vue.toasted.show('signUp fail.', {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		editAddress (userAddress, addressId) {
			delete userAddress.addressId
			return new Promise((resolve, reject) => {
				const putUrl = `${url.editAddressUrl}${addressId}`
				this.$http.put(putUrl, userAddress)
					.then((res) => {
						customerApi.getAddresses()
						Vue.toasted.show('Address Updated Successfully.', {
							position: 'top-center'
						})
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		removeAddress (addressId) {
			return new Promise((resolve, reject) => {
				const postUrl = `${url.removeAddress}${addressId}`
				this.$http.post(postUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getAddresses () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getAddress)
					.then((res) => {
						store.dispatch('user/setAddressData', res.data)
						this.$forceUpdate()
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		insertWishList () {
			const a = {}
			a.productIds = store.getters['wishlist/getWishListIds']
			const getChoosenCountry = JSON.parse(JSON.stringify(store.getters['siteData/getSelectedCountryCode']))
			const postUrl = `${url.insertWishList}${getChoosenCountry}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl, a)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		updateCustomer (userData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.updateCustomer, userData)
					.then((res) => {
						this.getCustomerDetails()
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getCustomerDetails () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getCustomerDetailsUrl)
					.then((res) => {
						store.dispatch('user/setUserData', res.data)
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		insertRecentlyViewedProducts (recentView) {
			const postUrl = `${url.insertRecentlyViewedProductsUrl}${recentView}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getRecentlyViewedProducts (recentDataIds) {
			let apiData
			if (recentDataIds) {
				apiData = recentDataIds
			} else {
				apiData = {
					productIds: JSON.parse(JSON.stringify(store.getters['recentview/getRecentViewedProducts']))
				}
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.getRecentlyViewedProductsUrl, apiData)
					.then((res) => {
						const products = res.data.productIds
						products.forEach((product) => {
							store.dispatch('recentview/setRecentProductsData', product)
						})
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getWishList () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getWishListUrl)
					.then((res) => {
						if (res.data && res.data.productIds) {
							productApi.getProductsByIds(res.data.productIds, 'wish-list').then((respo) => {
								for (let i = 0; i < respo.body.length; i += 1) {
									store.dispatch('wishlist/addToWishlist', respo.data[i].product_id)
								}
							}).catch((err) => {
								reject(err)
							})
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		reviewProduct (review) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.reviewUrl, review)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(`${e.body.message}`, {
							icon: 'exclamation-circle'
						})
						reject(e)
					})
			})
		},
		commentReview (value, reviewId, productId) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.commentReviewUrl, {
					comment_rating: value,
					product_id: productId,
					review_id: reviewId
				})
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getTenantConfigurations () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getTenantConfigurationsUrl).then((res) => {
					setDefaultCountryAndCurrency(res.body)
					resolve(res)
				})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getReview (productId) {
			const postUrl = `${url.getReviewUrl}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl, {
					product_id: productId
				})
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getNotification () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getNotificationUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		accountDeactivation () {
			return new Promise((resolve, reject) => {
				this.$http.post(url.accountDeactivationUrl)
					.then((res) => {
						Vue.toasted.show('Your account deactivated successfully.')
						store.dispatch('user/clearUserData')
						store.dispatch('cart/emptyCart')
						router.push('/')
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		uploadProfilePic (photo) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.uploadPpUrl, photo)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 413) {
							Vue.toasted.show('File Size is Too Large')
						} else {
							Vue.toasted.show('Error occurred while Uploading Photo')
						}
						reject(e)
					})
			})
		},
		updateProfilePic (photo) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.updatePpUrl, photo)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 413) {
							Vue.toasted.show('File Size is Too Large')
						} else {
							Vue.toasted.show('Error occurred while Updating Photo')
						}
						reject(e)
					})
			})
		},
		removeProfilePic (imageUrl) {
			const postUrl = `${url.removePpUrl}${imageUrl}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show('Error occurred while removing Photo')
						reject(e)
					})
			})
		},
		uploadReviewImages (files) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.uploadFilesUrl, files)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 413) {
							Vue.toasted.show('File Size is Too Large')
						} else {
							Vue.toasted.show('Error occurred while uploading Photo')
						}
						reject(e)
					})
			})
		},
		checkLoginStatus () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.checkLoginStatusUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		reportAbuse (reviewId, report) {
			const postUrl = `${url.reportAbuse}${reviewId}&report=${report}`
			return new Promise((resolve, reject) => {
				this.$http.post(postUrl)
					.then((res) => {
						this.$toasted.show('Thanks for reporting it. Our team will look into it at the earliest.')
						resolve(res)
					})
					.catch((e) => {
						if (e.data.status === 400) {
							this.$toasted.show('You already reported this review')
						}
						reject(e)
					})
			})
		},
		agentSignUpRequest (agentData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.agentRequest, agentData)
					.then((res) => {
						if (res.data.status === 200) {
							Vue.toasted.show('You have successfully registered and logged in.')
						}
						resolve(res)
					})
					.catch((e) => {
						if (e.data.status === 400) {
							Vue.toasted.show('Username already exist.')
						}
						reject(e)
					})
			})
		},
		notifyMe (productData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.notifyMeUrl, productData)
					.then((res) => {
						Vue.toasted.show(`${res.body.message}`, {
							icon: 'exclamation-circle'
						})
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		}
	}
})
